import {MuWidget} from "mu-widget/lib/MuWidget";

export class UiInput extends MuWidget {
    public unit: string|null = null;

    public auto: string|null = null;

    public type: string = 'text';

    public ifAuto: 'disable'|'hide' = 'hide';

    beforeIndex() {
        this.muAppendContent(`
            <div class="input-with-unit">
                <span class="c-input__auto" mu="autoContainer">
                    <input type="checkbox" mu="auto#auto">
                    <label mu-for="auto" mu="autoLabel"></label>
                </span>
                <input mu="value#value" />
                <span mu="unit"></span>
            </div>
        `);
        this.muRegisterEvent('input', 'change');
    }

    afterIndex() {
        this.muVisible(this.auto !== null, 'autoContainer');
        this.muVisible(this.unit !== null, 'unit');
        this.ui.value.type = this.type;
        this.ui.autoLabel.textContent = this.auto;
        this.ui.unit.textContent = this.unit;
    }

    auto_change(ev: Event|false) {
        this.updateWidget();
        if (ev) this.muDispatchEvent('input');
        if (ev) this.muDispatchEvent('change');
    }

    private updateWidget() {
        this.ui.value.style.visibility = !this.ui.auto.checked || this.ifAuto !== 'hide'
            ? 'visible' : '';
        this.ui.value.disabled = this.ui.auto.checked;
    }

    value_change() {}

    protected muAfterBindData() {
        this.auto_change(false);
    }
}